export default "__VITE_ASSET__kmOFGaQU__"